import React, { useEffect, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { connect } from "react-redux";
import { Menu, MenuItem, Fade } from "@mui/material";
import Switch from "@mui/material/Switch";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import toast from "react-hot-toast";

import EditUser from "./components/EditUser";
import AddSuperUser from "./components/AddSuperUser";
import CustomTableV2 from "../../common/CustomTableV2";
import CustomSliderModal from "../../common/CustomSliderModal";
import CustomModal from "../../common/CustomModal";
import CustomActionButton from "../../common/CustomActionButton";
import CustomButton from "../../common/CustomButton";
import CompanyAutocomplete from "../../common/CustomInput/companyAutocomplete";
import CustomSliderModalV2 from "../../common/CustomSliderModalV2";

import { delay } from "../../utils";
import { apiCallV2 } from "../../utils/api";
import {
    GetSuperUsers,
    UpdateCompanyAccess,
    AddCompanyAccess,
} from "../../redux/superUser/actions";

import "./style.css";

let timer = null;

function SuperUsers(props) {
    // component states
    const [sUserStore, setSUserStore] = useState([]);
    const [data, setData] = useState([]);
    const [user, setUser] = useState("");
    const [show, setShow] = useState(false);
    const [showType, setShowType] = useState(false);

    // menu states
    const [anchorEl, setAnchorEl] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState(null);
    const open = Boolean(anchorEl);
    const [currentIndex, setCurrentIndex] = useState("");

    const [openOptions, setOpenOptions] = useState(false);
    const [options, setOptions] = useState([]);
    const loading = open && options.length === 0;
    const [selectedCompany, setSelectedCompany] = useState(null);

    const handleClick = (event, index) => {
        setCurrentIndex(index);
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleUpdate = async () => {

        const userID = modalData?.user?.table_id;
        const companyID = modalData?.company?.company_id;
        const status = modalData?.company?.status ? 0 : 1;

        const res = await props.UpdateCompanyAccess(
            userID,
            companyID,
            status,
            sUserStore.list
        );

        if (res?.success) {
            toast.success("Access Updated!");

            delay(() => {
                setShowModal(false);
            }, 2000);

            return true;
        }

        if (res.data.status === 500) {
            toast.error(res.message);
            return false;
        }
    };

    const updateSUserDrawer = (index) => {
        let temp = [...sUserStore.list];

        temp = temp.map((su, i) => {
            return i != index
                ? su
                : {
                    ...su,
                    show: su.hasOwnProperty("show") ? !su?.show : true,
                };
        });

        setSUserStore({
            ...sUserStore,
            list: temp,
        });
    };

    const handleOptions = async (value) => {
        setOptions([]);
        clearTimeout(timer);
        timer = setTimeout(async () => {
            const res = await apiCallV2("POST", "common/getData", {
                page: null,
                count: null,
                tableName: "company",
                filters: { fullName: value },
                fetchAll: true,
            });
            setOptions(res.data.company);
        }, 600);
    };

    const addCompanyAccess = async () => {
        const userID = modalData?.user?.table_id;


        const res = await props.AddCompanyAccess(
            userID,
            selectedCompany,
            sUserStore.list
        );

        if (res?.success) {
            toast.success("Company Access Addded!");

            delay(() => {
                setShowModal(false);
            }, 2000);

            return true;
        }
    };


    useEffect(() => {
        setSUserStore(props.SuperUser);
    }, [props.SuperUser]);

    return (
        <div
            className="main-container"
        >
            <CustomModal
                toggle={() => {
                    setShowModal(!showModal);
                }}
                show={showModal}
                title={
                    modalData?.company?.status
                        ? "Remove Access"
                        : "Grant Access"
                }
                body={
                    <>
                        {modalData?.type == "update" && (
                            <div id="update-access-modal-body">
                                <p>
                                    Are you sure you want to{" "}
                                    {modalData?.company?.status
                                        ? "remove"
                                        : "grant"}{" "}
                                    <h5>{modalData?.user?.firstname}'s</h5>{" "}
                                    access to{" "}
                                    <h5>{modalData?.company?.companyName}</h5>?
                                </p>

                                <CustomActionButton action={handleUpdate}>
                                    {modalData?.company?.status
                                        ? "Remove"
                                        : "Grant"}
                                </CustomActionButton>
                            </div>
                        )}

                        {modalData?.type == "add" && (
                            <div id="add-access-modal-body">
                                <p>
                                    User:{" "}
                                    <h5>
                                        {modalData?.user?.firstname +
                                            " " +
                                            modalData?.user?.lastname}
                                    </h5>
                                </p>

                                <CompanyAutocomplete
                                    handleOptions={handleOptions}
                                    open={openOptions}
                                    setOpen={setOpenOptions}
                                    loading={loading}
                                    setOptions={setOpenOptions}
                                    options={options}
                                    setSelected={setSelectedCompany}
                                />

                                <CustomActionButton action={addCompanyAccess}>
                                    Grant
                                </CustomActionButton>
                            </div>
                        )}
                    </>
                }
            />

            <Fade in>
                <div>
                    <CustomTableV2
                        title="SUPER USERS"
                        description="Control permission of super users."
                        store={sUserStore}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "Last Name", value: "lastname" },
                                { title: "First Name", value: "firstname" },
                                { title: "Email Address", value: "email" },
                                { title: "" },
                            ],
                            body: (sUser, i) => {
                                return (
                                    <>
                                        <tr
                                            className={`clickable ${i % 2 == 0 ? "tr-even" : ""
                                                }`}
                                            onClick={(e) => {
                                                if (
                                                    e.target.nodeName == "TD" ||
                                                    e.target.nodeName == "H5"
                                                ) {
                                                    updateSUserDrawer(i - 1);
                                                }
                                            }}
                                        >
                                            <td>
                                                <h5>{i}</h5>
                                            </td>
                                            <td>
                                                <h5>{sUser.lastname?.toUpperCase()}</h5>
                                            </td>
                                            <td>
                                                <h5>{sUser.firstname?.toUpperCase()}</h5>
                                            </td>
                                            <td>
                                                <h5>
                                                    {sUser.email}
                                                </h5>
                                            </td>
                                            <td>
                                                <h5>
                                                    <MoreHorizIcon
                                                        id="basic-button"
                                                        onClick={(e) =>
                                                            handleClick(e, i)
                                                        }
                                                        sx={{
                                                            fontSize: 40,
                                                            cursor: "pointer",
                                                        }}
                                                    />
                                                    {i === currentIndex && (
                                                        <Menu
                                                            sx={{ zIndex: 800 }}
                                                            id="basic-menu"
                                                            anchorEl={anchorEl}
                                                            open={open}
                                                            onClose={
                                                                handleClose
                                                            }
                                                            MenuListProps={{
                                                                "aria-labelledby":
                                                                    "basic-button",
                                                            }}
                                                        >
                                                            <MenuItem
                                                                onClick={() => {
                                                                    handleClose();
                                                                    setUser(
                                                                        sUser
                                                                    );
                                                                    setShow(
                                                                        true
                                                                    );
                                                                    setShowType(
                                                                        "edit"
                                                                    );
                                                                }}
                                                            >
                                                                <EditIcon
                                                                    sx={{
                                                                        mr: "10px",
                                                                    }}
                                                                />{" "}
                                                                Edit
                                                            </MenuItem>
                                                        </Menu>
                                                    )}
                                                </h5>
                                            </td>
                                        </tr>

                                        {sUser?.companies.length > 0 && (
                                            <tr
                                                className={`su-sub-row ${sUser?.show ? "show" : ""
                                                    }`}
                                            >
                                                <td colSpan={5}>
                                                    <div
                                                        style={{
                                                            height: sUser?.show
                                                                ? sUser
                                                                    ?.companies
                                                                    .length *
                                                                50 +
                                                                40 +
                                                                "px"
                                                                : "0px",
                                                        }}
                                                    >
                                                        <h5>
                                                            Company Access:
                                                            <CustomButton
                                                                className="active"
                                                                onClick={() => {
                                                                    setShowModal(
                                                                        true
                                                                    );
                                                                    setModalData(
                                                                        {
                                                                            user: sUser,
                                                                            type: "add",
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                Add Company
                                                            </CustomButton>
                                                        </h5>
                                                        {sUser?.companies?.map(
                                                            (c, i) => {
                                                                return (
                                                                    <div>
                                                                        <p>
                                                                            {
                                                                                c?.companyName
                                                                            }
                                                                        </p>
                                                                        <Switch
                                                                            size="small"
                                                                            checked={
                                                                                c?.status
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) => {

                                                                                setShowModal(
                                                                                    true
                                                                                );
                                                                                setModalData(
                                                                                    {
                                                                                        user: sUser,
                                                                                        company:
                                                                                            c,
                                                                                        type: "update",
                                                                                    }
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                );
                            },
                        }}
                        actions={{
                            get: (page, count, filter, sort) => {
                                props.GetSuperUsers(page, count, filter, sort);
                            },
                            add: () => {
                                setShow(true);
                                setShowType("add");
                            },
                        }}
                    />
                </div>
            </Fade>

            <CustomSliderModalV2
                show={show}
                setShow={setShow}
                title={(showType == "add" ? "ADD" : "EDIT") + " SUPER USER"}
            >
                {showType == "add" && (
                    <AddSuperUser
                        setOpenAddSuperUser={() => {
                            setShow(false);
                        }}
                    />
                )}
                {showType == "edit" && (
                    <EditUser
                        data={data}
                        setData={setData}
                        setOpenEditSuperUser={() => {
                            setShow(false);
                        }}
                        user={user || ""}
                    />
                )}
            </CustomSliderModalV2>
        </div>
    );
}

const mapStateToProps = (state) => ({
    SuperUser: state.SuperUser,
});

export default connect(mapStateToProps, {
    GetSuperUsers,
    UpdateCompanyAccess,
    AddCompanyAccess,
})(SuperUsers);
